

export default class Context{

    static data = {};

    constructor(){
        Context.context = context ?? {};
    }

    static set( field , value ){
        Context.data[ field ] = value;
    }

    static get( field ){
        return Context.data[ field ] ?? null;
    }
}
